import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children, roles }) => {
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  if (!isLoggedIn || !user?.access_token) {
    return <Navigate to="/login" replace />;
  }
  if (roles && !roles.includes(user.user_type)) {
    return <Navigate to="/unauthorized" replace />;
  }
  return children;
};

export default PrivateRoute;
